export default __webpack_public_path__ + "static/media/ad_4.998fd265.mp3";